import { useLocation, useNavigate } from 'react-router-dom';

// Ana sayfadaysa bölüme kaydırır; başka sayfadaysa ana sayfaya gidip
// HomePage'in location.state.scrollTo ile kaydırmasını sağlar.
export function useSectionNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (id: string) => {
    if (pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };
}
